import { SPONSOR } from '@/constants/sponsor';
import { IDS } from '@/constants/testIds';
import { Phone, Zap } from 'lucide-react';
import { trackSponsorClick } from '@/lib/tracking';

export default function SponsorBanner() {
  const items = Array.from({ length: 6 });
  return (
    <div
      data-testid={IDS.sponsorBanner}
      className="bg-amber-500 text-zinc-950 border-y border-amber-600 overflow-hidden py-2"
    >
      <div className="marquee-track font-mono text-sm font-semibold uppercase tracking-wider">
        {items.map((_, i) => (
          <span key={`sponsor-loop-${i}`} className="flex items-center gap-2">
            <Zap size={16} strokeWidth={2.5} />
            Electrical Pro: {SPONSOR.name} · {SPONSOR.city}
            <a
              data-testid={i === 0 ? IDS.sponsorCall : undefined}
              href={SPONSOR.phoneHref}
              onClick={() => trackSponsorClick('banner')}
              className="inline-flex items-center gap-1 underline hover:no-underline"
            >
              <Phone size={14} strokeWidth={2.5} /> {SPONSOR.phone}
            </a>
            <span className="text-amber-800">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
